// src/utils/roleFrameworkData.js
// Display constants for the BRIO Role Framework.
// Role data is now loaded dynamically from CSV via useRoleFramework().

// ── Competency category definitions ────────────────────────────────────────
export const COMPETENCY_GROUPS = [
  {
    name: 'Design',
    competencies: [
      { key: 'drawings_2d',           label: '2D Drawings' },
      { key: 'modelling_3d',          label: '3D Modelling' },
      { key: 'presentation_graphics', label: 'Presentation Graphics' },
      { key: 'concept_design',        label: 'Concept Design' },
      { key: 'detail_resolution',     label: 'Detail Resolution' },
    ],
  },
  {
    name: 'Technical',
    competencies: [
      { key: 'gfc_drawings',        label: 'GFC Drawings' },
      { key: 'gfc_checking',        label: 'GFC Checking' },
      { key: 'bim_coordination',    label: 'BIM Coordination' },
      { key: 'specification_writing', label: 'Specification Writing' },
      { key: 'authority_approvals', label: 'Authority Approvals' },
    ],
  },
  {
    name: 'Coordination & Delivery',
    competencies: [
      { key: 'consultant_vendor_coordination', label: 'Consultant & Vendor Coordination' },
      { key: 'site_supervision',               label: 'Site Supervision' },
      { key: 'cost_control',                   label: 'Cost Control' },
      { key: 'time_management',                label: 'Time Management' },
      { key: 'contract_administration',        label: 'Contract Administration' },
    ],
  },
  {
    name: 'Leadership & Practice',
    competencies: [
      { key: 'training_support_juniors',        label: 'Training & Supporting Juniors' },
      { key: 'project_acquisition_new_clients', label: 'Project Acquisition / New Clients' },
      { key: 'design_quality_accountability',   label: 'Design Quality Accountability' },
      { key: 'budget_programme_accountability', label: 'Budget & Programme Accountability' },
    ],
  },
];

// ── Role colours (aligned with BRIO_ROLE_COLORS in AnalyticsDashboardPage) ──
export const ROLE_STYLE = {
  A: { bg: '#fdf0e8', border: '#f0b596', text: '#7a3b18', chip: '#f0b596' },
  B: { bg: '#f5f3e8', border: '#d9d3aa', text: '#4d4618', chip: '#d9d3aa' },
  C: { bg: '#ede9d0', border: '#b2a655', text: '#3e3510', chip: '#b2a655' },
  D: { bg: '#e4e0c8', border: '#7f7322', text: '#332e0d', chip: '#7f7322' },
  E: { bg: '#d8e8e2', border: '#689581', text: '#1e4035', chip: '#689581' },
  F: { bg: '#ede4d8', border: '#a97e53', text: '#4a2e10', chip: '#a97e53' },
  G: { bg: '#e2e0d4', border: '#8a7d3e', text: '#3a3210', chip: '#8a7d3e' },
  H: { bg: '#d8d4c8', border: '#6b6020', text: '#2e2a0c', chip: '#6b6020' },
};
